<template>
  <b-nav v-if="navPermissions['portalAdmin'].enable">
    <b-nav-item-dropdown
        id="my-nav-dropdown "
        text="Portal Administration"
        toggle-class="nav-link-custom"
    >
      <template slot="button-content">
        <i class="fa mr-2 fa-lock text-info" font-scale="1"></i>
        <span>Administration</span>
      </template>
      <b-dropdown-item to="/data_management">
        <i class="fa fa-database text-success" font-scale="1"></i>
        Data Management
      </b-dropdown-item>
      <b-dropdown-item to="/data_management">
        <i class="fa fa-table text-indigo" font-scale="1"></i>
        Inventory Management
      </b-dropdown-item>
      <b-dropdown-item to="/tower_management">
        <i class="fa fa-podcast text-yellow" font-scale="1"></i>
        Tower Management
      </b-dropdown-item>
      <b-dropdown-item to="/admin/user_admin">
        <i class="fa fa-user text-danger pr-2"></i>
        <span class="nav-link-text">User Management</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>
<script>
import initService from "@/common/api-services/init-service";

export default {
  name: 'top-admin-custom-group',
  components: {},


  data() {
    return {
      isPortalAdminStatus: false,
      isAdminStatus: false,
      groups: [],

      adminCollaps: false,
      link: {
        name: '',
        icon: '',
        path: '',
        children: []
      },

      navPermissions: {
        "portalAdmin": {
          enable: false,
          role: ["Administrator"],
          data: {
            "adminAccess": {
              enable: false,
              role: ["Administrator"]
            },
          }
        }
      }
    }
  },

  mounted() {
    this.isPortalAdminStatus = initService.getPortalAdminRole();
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
    this.groups = initService.getGroups();
    Object.keys(this.navPermissions).map(item => {
      this.groups.map(it => {
        if (this.navPermissions[item].role.includes(it)) this.navPermissions[item].enable = true;
      });
    });
  }
}

</script>